/**
 * Shim pour react-google-maps/lib/constants.
 * Utilise le React de l'app (même instance que le bundle) pour createContext,
 * ce qui évite "Cannot read properties of undefined (reading 'createContext')"
 * quand react-google-maps est chargé avant que require("react") soit prêt.
 */
"use strict";

const React = require("react");
const R = (React && (React.default || React)) || null;
if (!R || typeof R.createContext !== "function") {
	throw new Error(
		"react-google-maps-constants-shim: React.createContext non disponible. Vérifiez que 'react' est bien résolu par webpack."
	);
}

const MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const MARKER = "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const MARKER_WITH_LABEL = "__SECRET_MARKER_WITH_LABEL_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const RECTANGLE = "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const POLYLINE = "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const POLYGON = "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const CIRCLE = "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const KML_LAYER = "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const DIRECTIONS_RENDERER = "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const HEATMAP_LAYER = "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const FUSION_TABLES_LAYER = "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const ANCHOR = "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const INFO_WINDOW = "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const OVERLAY_VIEW = "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const GROUND_LAYER = "__SECRET_GROUND_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const DRAWING_MANAGER = "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const SEARCH_BOX = "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const MARKER_CLUSTERER = "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const INFO_BOX = "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const TRAFFIC_LAYER = "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const STREET_VIEW_PANORAMA = "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";
const BICYCLING_LAYER = "__SECRET_BICYCLING_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

const MapContext = R.createContext(null);
const MapChildContext = R.createContext(null);

exports.__esModule = true;
exports.MAP = MAP;
exports.MapContext = MapContext;
exports.MapChildContext = MapChildContext;
exports.MARKER = MARKER;
exports.MARKER_WITH_LABEL = MARKER_WITH_LABEL;
exports.RECTANGLE = RECTANGLE;
exports.POLYLINE = POLYLINE;
exports.POLYGON = POLYGON;
exports.CIRCLE = CIRCLE;
exports.KML_LAYER = KML_LAYER;
exports.DIRECTIONS_RENDERER = DIRECTIONS_RENDERER;
exports.HEATMAP_LAYER = HEATMAP_LAYER;
exports.FUSION_TABLES_LAYER = FUSION_TABLES_LAYER;
exports.ANCHOR = ANCHOR;
exports.INFO_WINDOW = INFO_WINDOW;
exports.OVERLAY_VIEW = OVERLAY_VIEW;
exports.GROUND_LAYER = GROUND_LAYER;
exports.DRAWING_MANAGER = DRAWING_MANAGER;
exports.SEARCH_BOX = SEARCH_BOX;
exports.MARKER_CLUSTERER = MARKER_CLUSTERER;
exports.INFO_BOX = INFO_BOX;
exports.TRAFFIC_LAYER = TRAFFIC_LAYER;
exports.STREET_VIEW_PANORAMA = STREET_VIEW_PANORAMA;
exports.BICYCLING_LAYER = BICYCLING_LAYER;
